/** Monotonic milliseconds; `performance.now()` when available (tests spy on it), else wall clock. */
export const monotonicNow = (): number => {
  const { performance } = globalThis;

  return performance && typeof performance.now === 'function' ? performance.now() : Date.now();
};
